import React from 'react';

import MarketOverview from './static/MarketOverview';
import TrendsSummary from './TrendsSummary';
import StaticSection from './static/StaticSection';
import FullAccessBanner from './FullAccessBanner';
import { SECTIONS_IDS } from '../configs/sections';

const AiDashboardStaticView = () => (
  <>
    <div id={SECTIONS_IDS.marketOverview}>
      <MarketOverview />
    </div>

    <div className="separator-h" />
    <FullAccessBanner />

    <div id={SECTIONS_IDS.behavioralTrends} className="d-flex flex-column gap-24">
      <TrendsSummary allowQV={false} />
      <StaticSection variant="behavioral-trends" height={475} />
    </div>

    <div id={SECTIONS_IDS.marketBehavior}>
      <StaticSection variant="market-behavior" height={1712} />
    </div>

    <div id={SECTIONS_IDS.screenTimeBySector}>
      <StaticSection variant="screen-time-by-sector" height={827} />
    </div>

    <div id={SECTIONS_IDS.appTrends}>
      <StaticSection variant="app-trends" height={981} />
    </div>

    <div id={SECTIONS_IDS.aiAppImpact}>
      <StaticSection variant="ai-app-impact" height={597} />
    </div>
  </>
);

export default AiDashboardStaticView;
